import { render, staticRenderFns } from "./MantenedorEndpoints.vue?vue&type=template&id=2d47ea16&scoped=true&"
import script from "./MantenedorEndpoints.vue?vue&type=script&lang=ts&"
export * from "./MantenedorEndpoints.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorEndpoints.vue?vue&type=style&index=0&id=2d47ea16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47ea16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2d47ea16', component.options)
    } else {
      api.reload('2d47ea16', component.options)
    }
    module.hot.accept("./MantenedorEndpoints.vue?vue&type=template&id=2d47ea16&scoped=true&", function () {
      api.rerender('2d47ea16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MID/MantenedorEndpoints.vue"
export default component.exports